var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.414,
    height: 14.914,
    viewBox: "0 0 16.414 14.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.293 -8.793)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.5 12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15,0,7.5,7.5,0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.5 12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15,0,7.5,7.5,0,0"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDownArrow);
export default __webpack_public_path__ + "static/media/DoubleDownArrow.29489db2f2627eba421cfb3a882d3a39.svg";
export { ForwardRef as ReactComponent };